import { render, staticRenderFns } from "./cefloreco-benefis.vue?vue&type=template&id=676d9432&scoped=true&"
import script from "./cefloreco-benefis.vue?vue&type=script&lang=js&"
export * from "./cefloreco-benefis.vue?vue&type=script&lang=js&"
import style0 from "./cefloreco-benefis.vue?vue&type=style&index=0&id=676d9432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d9432",
  null
  
)

export default component.exports